import axios from "axios"

export const offer = {
    state: () => ({
        offer: {content: ''},
    }),
    getters: {
        offer(state){
            return state.offer
        },
        offerContent(state){
            return state.offer?.content || ''
        },
    },

    mutations:{
        offer(state,payload){
            state.offer = payload
        },
    },

    actions:{
        getOffer(context){
            axios.get(`${context.getters.url}/offer`)
            .then(res=> {
                if (res.status==200){
                    context.commit('offer',res.data)
                }
            })
        },
    }
}
